module.exports = __webpack_public_path__ + "img/Location.f61e89bc.gif";